import React from 'react';
import { st, classes } from '../style/ProGallery.component.st.css';

// TODO - fix types
export default (props: any) => (
  <div className={st(classes.info)}>
    <p>{props.title}</p>
  </div>
);
